// extracted by mini-css-extract-plugin
export default {"root":"cR_EFlTitwYPGWpQckc9","icon":"AMK2RDB0spIxeVdcvN7D"};